import { useMutation } from '@tanstack/react-query'

import { updatePaymentRequestEvidenceFile } from '@src/api'
import { DefaultApiUpdatePaymentRequestEvidenceFileRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdatePaymentRequestEvidenceFile = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdatePaymentRequestEvidenceFileRequest) =>
      updatePaymentRequestEvidenceFile(axiosInstance, params),
  })
}
